import ActionType from 'actions/ActionType'

export default (state = 'preview', action) => {
	switch (action.type) {
		case ActionType.SignupForm.TOGGLE_PREVIEW_RESPONSE_VIEW:
			if (typeof action.payload === 'string') {
				return action.payload
			}

			return state === 'preview' ? 'response' : 'preview'
		case ActionType.SignupForm.RECEIVE_FORM:
			if (!action.payload) {
				return 'preview'
			}
			return state
		case '@@router/LOCATION_CHANGE':
			if (action.payload.location.pathname === '/forms/new') {
				return 'preview'
			}
			return state
		default:
			return state
	}
}